import { useState, useEffect, useContext } from 'react';
import { Chains } from 'api/types/httpsTypes/d-wallets';
import { HotTokensPeriods } from '../../app/dex/research/components/Wallets/usePageParams';
import { transFormPeriodInMinutes } from 'api/services/httpServices/ContractService';
import { WebSocketContext } from 'api/services/websocket/websocketProvider';

export type TokenStatsWebSocketShortMessage = {
  c: Chains; // chain
  a: string; // tokenAddress
  swb: number; // suspiciousWalletsBuy
  rwb: number; // rugAddictedWalletsBuy
  scb: number; // scammerWalletsBuy
  fwb: number; // freshWalletsBuy
  s: string; // status
  twbt: number; // totalWalletsBuyTop
  twb: number; // totalWalletsBuy
  twst: number; // totalWalletsSellsTop
  tws: number; // totalWalletsSells
  bvt: string; // buyVolumeTop
  bv: string; // buyVolume
  sv: string; // sellVolume
  svt: string; // sellVolumeTop
  btx: number; // buyTxPeriod
  stx: number; // sellTxPeriod
  sp: number; // token price previous period
  v: string; // volumePeriod
  p: string; // currentPrice
  pc: string; // priceChangePeriod
  l: string; // currentLiquidity
  m: string; // currentMarketCap
  nit: string; // netInflowTop
  ni: string; // netInflow
  vi: string; // volatilityIndex
  t: number; // timeframe
};

export const useTokenStats = (
  chain: Chains,
  address: string,
  timePeriod: HotTokensPeriods
): TokenStatsWebSocketShortMessage | null => {
  const wsContext = useContext(WebSocketContext);
  const [stats, setStats] = useState<TokenStatsWebSocketShortMessage | null>(
    null
  );

  const timeFrame = transFormPeriodInMinutes(timePeriod);

  useEffect(() => {
    if (!wsContext) return;

    const dataKey = { chain, address, timeFrame };

    // ✅ Get latest message from cache
    const cached = wsContext.getLatestMessage('token_stats', dataKey);
    if (cached?.data) {
      setStats(cached.data as TokenStatsWebSocketShortMessage);
    }

    // ✅ Listen for updates
    const handleUpdate = (msg: any) => {
      const parsed = msg.data as TokenStatsWebSocketShortMessage;

      if (
        parsed.c === chain &&
        parsed.a === address &&
        parsed.t === timeFrame
      ) {
        setStats(parsed);
      }
    };

    wsContext.addMessageListener('token_stats', dataKey, handleUpdate);

    return () => {
      wsContext.removeMessageListener('token_stats', dataKey, handleUpdate);
    };
  }, [wsContext, chain, address, timeFrame]);

  return stats;
};
